// sling-sdk/src/featureFlags/types is a pure enum module with no imports of
// its own, so it is safe to load in the headless bundle; the LD client itself
// is only required behind the __HEADLESS__ guard below. If types ever grows a
// transitive import of the LD client, the mocha-headless suite fails the build.
import { LdFeatureFlags } from 'sling-sdk/src/featureFlags/types';

import config from '../../config';

// SLING-1021: single source of truth for the CDN-resize gate, split by bundle
// (RF-35411 follow-up).
//
// - Headless/print bundle: returns the deploy-toggled constant
//   config.CDN_RESIZE_ENABLED and NEVER touches LaunchDarkly. The print
//   renderer waits for networkidle0, so any persistent LD connection wedges
//   PDF generation. __HEADLESS__ is a webpack DefinePlugin constant (true in
//   webpack.headless.babel.js), so webpack's parser drops the LD require —
//   and the LD client module — from the headless bundle at build time. The
//   typeof guard matches the SDK's launchdarkly client and keeps the module
//   ReferenceError-proof in contexts loaded without the webpack/test
//   bootstrap; DefinePlugin folds typeof of a defined constant, so the
//   dead-code elimination is unaffected.
// - Live app: reads the ec-sling-cdn-resize-enabled LD flag so the Cloudinary
//   cutover can ramp by percentage (SLING-934 §4), using the config constant
//   as the default until the LD client is ready and when LD has no value.
//
// Call sites stay synchronous (#10070): the LD client resolves once at module
// load and each call then reads the current flag value from it, so streaming
// flag updates apply without a reload.
let _ldClient = null;

if (typeof __HEADLESS__ === 'undefined' || !__HEADLESS__) {
  // eslint-disable-next-line global-require
  const getFeatureFlagClient = require('sling-sdk/src/featureFlags/launchdarkly').default;
  getFeatureFlagClient().then((client) => {
    _ldClient = client;
  }).catch((error) => {
    // isCdnResizeEnabled() keeps returning config.CDN_RESIZE_ENABLED for the
    // session when LD init fails.
    console.error('Failed to initialize LaunchDarkly client:', error);
  });
}

export default function isCdnResizeEnabled() {
  if (!_ldClient) {
    return config.CDN_RESIZE_ENABLED;
  }
  return _ldClient.isFeatureEnabled(LdFeatureFlags.CDN_RESIZE_ENABLED, config.CDN_RESIZE_ENABLED);
}
